<section class="policy-service-shared" [ngClass]="customClass">
  <div class="box">
    <div class="box-left">
      <ng-container *ngFor="let item of contentMenu">
        <a [routerLink]="getRouterLink(item.link)" routerLinkActive="current" class="box-left__navigation">
          <span>{{ item.label | translate }}</span>
        </a>
      </ng-container>
    </div>
    <div class="box-right">
      <h1 class="box-right__title"
        ><span>{{ 'POLICY_SERVICE.TITLE' | translate }}</span></h1
      >
      <div class="box-right__detail">
        <ng-container *ngFor="let item of loopArray(); let index = index">
          <p [innerHTML]="'POLICY_SERVICE.DETAILS.' + (index + 1) | translate"></p>
        </ng-container>
      </div>
    </div>
  </div>
</section>
